import { RevenueReportPartnerListPage } from "@/features/revenue-report-partner/pages/RevenueReportPartnerListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-report-partner/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_partner.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportPartnerListPage,
});
